import MoreInfo from './MoreInfo'

export default MoreInfo
